var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"gap":"thin"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('PageHeaderAdfox')]},proxy:true}])},[_vm._v(" "),_c('ScannerInfo',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }